import React from "react"
import "./layout.css"
import { GlobalStyle } from "../styles/GlobalStyle"
import Header from "./Header"
import Alert from "./Alert"
import "veucss/dist/css/veu.css"

function Layout({ children }) {
  return (
    <>
      <GlobalStyle />
      <main className="__veu">{children}</main>
      <section
        className="_veu"
        style={{
          textAlign: "center",
          paddingLeft: "1.25rem",
          paddingRight: "1.25rem",
          marginLeft: "auto",
          marginRight: "auto",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            color: "rgba(51,51,51,1)",
            textAlign: "center",
            paddingTop: "2.5rem",
            paddingBottom: "2.5rem",
            fontSize: "1.25rem",
            flex: "1 1 0%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "700",
              fontSize: "1.25rem",
            }}
          >
            <img
              src="https://www.joinclubhouse.com/static/img/icon_wave.2872aeea710c.png"
              alt="Wave"
              className="__veu__wave"
            />
            Veu CSS
          </div>
          <div
            style={{
              color: "rgba(79,79,79,1)",
              maxWidth: "28rem",
              marginTop: "2rem",
              textAlign: "center",
              fontSize: "1.25rem",
            }}
          >
            Hey, sorry for the delay, a responsive website design is being made.
          </div>
          <div
            style={{
              color: "rgba(79,79,79,1)",
              paddingLeft: ".25rem",
              paddingRight: ".25rem",
              maxWidth: "28rem",
              marginTop: "2rem",
              fontSize: ".875rem",
              textAlign: "center",
            }}
          >
            You can view the full website on your computer
          </div>
        </div>
        <footer style={{ position: "absolute", bottom: "45px" }}>
          <ul
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <li
              style={{
                display: "flex",
                color: "rgba(84,118,170,1)",
                textAlign: "center",
                lineHeight: "2",
                fontSize: ".875rem",
                cursor: "pointer",
              }}
            >
              Home{" "}
              <span
                style={{
                  color: "rgba(255,175,82,1)",
                  paddingLeft: ".25rem",
                  paddingRight: ".25rem",
                  fontSize: ".875rem",
                  textAlign: "center",
                  lineHeight: "2",
                  fontWeight: "200",
                }}
              >
                ・
              </span>
            </li>
            <li
              style={{
                display: "flex",
                color: "rgba(84,118,170,1)",
                textAlign: "center",
                lineHeight: "2",
                fontSize: ".875rem",
                cursor: "pointer",
              }}
            >
              Documentation{" "}
              <span
                style={{
                  color: "rgba(255,175,82,1)",
                  paddingLeft: ".25rem",
                  paddingRight: ".25rem",
                  fontSize: ".875rem",
                  textAlign: "center",
                  lineHeight: "2",
                  fontWeight: "200",
                }}
              >
                ・
              </span>
            </li>
            <li
              style={{
                display: "flex",
                color: "rgba(84,118,170,1)",
                textAlign: "center",
                lineHeight: "2",
                fontSize: ".875rem",
                cursor: "pointer",
              }}
            >
              Blog{" "}
              <span
                style={{
                  color: "rgba(255,175,82,1)",
                  paddingLeft: ".25rem",
                  paddingRight: ".25rem",
                  fontSize: ".875rem",
                  textAlign: "center",
                  lineHeight: "2",
                  fontWeight: "200",
                }}
              >
                ・
              </span>
            </li>
            <li
              style={{
                display: "flex",
                color: "rgba(84,118,170,1)",
                textAlign: "center",
                lineHeight: "2",
                fontSize: ".875rem",
                cursor: "pointer",
              }}
            >
              Privacy{" "}
            </li>
          </ul>
        </footer>
      </section>
    </>
  )
}

export default Layout
